import { render } from "./AdminProductosCategorias.vue?vue&type=template&id=2723127b"
import script from "./AdminProductosCategorias.vue?vue&type=script&lang=js"
export * from "./AdminProductosCategorias.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__